export default "__VITE_ASSET__DIZxkgZm__"